import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import pxToRem from 'styles/pxToRem';

const styles = () => ({
  root: {
    fontSize: pxToRem(18),
  },
});

const SectionTitle = ({
  className, classes, children, ...otherProps
}) => (
  <Typography
    className={classNames(className, classes.root)}
    variant="subheading"
    {...otherProps}
  >
    {children}
  </Typography>
);

SectionTitle.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
  }).isRequired,
};

SectionTitle.defaultProps = {
  className: '',
};

export default withStyles(styles)(SectionTitle);



// WEBPACK FOOTER //
// ./src/components/common/Section/SectionTitle.js